const T = require('prop-types');
const { push: Push } = require('connected-react-router');
const { makeActionCreator } = require('../utils/redux-helpers');
const { APP: Types } = require('../action-types');
const { ELEMENT_IDS, USERS_SORT_TYPE } = require('utils/constants');

const internals = {};

module.exports = (context) => {

    const api = context.api.nearpeer;
    const actions = context.actions;
    const selectors = context.selectors.all;
    const redux = context.redux.hooks;
    let reviewRequestId = 0;

    return {
        setMainAppLoading:       makeActionCreator(Types.SET_MAIN_APP_LOADING,       { appLoading: T.bool }),
        setSchoolSwitchingState: makeActionCreator(Types.SET_SCHOOL_SWITCHING_STATE, { switchingToSchool: T.bool }),
        setRoleGroupFilter:      makeActionCreator(Types.UPDATE_ROLE_GROUP_FILTER,   { discover: T.string, dms: T.string, groups: T.string, admin: T.string }),
        setInterestsSearchText:  makeActionCreator(Types.SET_INTERESTS_SEARCH_TEXT,  { interestsSearchText: T.string }),
        setAppMessage:           makeActionCreator(Types.SET_APP_MESSAGE,            { key: T.string, title: T.string, message: T.string }),
        clearAppMessage:         makeActionCreator(Types.CLEAR_APP_MESSAGE,          { key: T.string }),
        setDiscoverSortType:     makeActionCreator(Types.UPDATE_DISCOVER_SORT_TYPE,  { type: T.string }),
        setDMsFilter:            makeActionCreator(Types.UPDATE_CONNECTIONS_FILTER,  { filter: T.string }),
        setAppReviewStatus:      makeActionCreator(Types.UPDATE_APP_REVIEW_STATUS,   { status: T.string }, {
            async: api.appFeedback.updateReviewStatus
        }),
        setUserReviewStatus: makeActionCreator(Types.SET_USER_REVIEW_STATUS, { status: T.bool }),
        fetchUserReviewAvailableStatus: () => (dispatch, getState) => {

            const requestId = ++reviewRequestId;
            const getSession = () => {

                const state = getState();

                return [
                    selectors.getIsAuthenticated(state),
                    selectors.getApiToken(state),
                    selectors.getCurrentUserId(state),
                    selectors.getCurrentSchoolId(state)
                ];
            };
            const session = getSession();

            dispatch(actions.app.setUserReviewStatus({ status: false }));

            if (!session[0]) {
                return Promise.resolve();
            }

            // Keep session credentials in this closure, outside action payloads.
            const fetchStatus = makeActionCreator(Types.FETCH_USER_REVIEW_AVAILABLE_STATUS, {}, {
                async: api.appFeedback.fetchUserReviewAvailableStatus,
                after: ({ payload: { result: { data: { status } } } }) => {

                    if (requestId === reviewRequestId
                        && getSession().every((value, index) => value === session[index])) {
                        dispatch(actions.app.setUserReviewStatus({ status }));
                    }
                }
            });

            return dispatch(fetchStatus());
        },
        checkUserIp: makeActionCreator(Types.CHECK_USER_IP, {}, {
            async: api.checkIp,
            after: ({ dispatch, payload: { result: { data: countryCode } } }) => {

                if (countryCode === 'PK') {
                    dispatch(Push('/nearpeer-pakistan'));
                }
            }
        }),
        setDiscoverSearchFilter:    makeActionCreator(Types.UPDATE_CLASSMATE_DISCOVER_SEARCH_FILTER, { filter: T.object }),
        setNotifySearchCriteria:    makeActionCreator(Types.UPDATE_NOTIFY_SEARCH_FILTER,      { filter: T.object }),
        setSurveySearchCriteria:    makeActionCreator(Types.UPDATE_SURVEY_SEARCH_FILTER,      { filter: T.object }),
        setSurveysManagementFilter: makeActionCreator(Types.UPDATE_SURVEYS_MANAGEMENT_FILTER, { filter: T.string }),
        setFirebaseToken:           makeActionCreator(Types.SET_FIREBASE_TOKEN,               { token: T.string }),
        setAppInBackground:         makeActionCreator(Types.SET_IN_BACKGROUND,                { inBackground: T.bool }),
        openNotifications:          makeActionCreator(Types.OPEN_NOTIFICATIONS,               {}),
        closeNotifications:         makeActionCreator(Types.CLOSE_NOTIFICATIONS,              {}),
        openLogoutDialog:           makeActionCreator(Types.OPEN_LOGOUT_DIALOG,               {}),
        closeLogoutDialog:          makeActionCreator(Types.CLOSE_LOGOUT_DIALOG,              {}),
        openModal:                  makeActionCreator(Types.OPEN_MODAL,                       {}),
        closeModal:                 makeActionCreator(Types.CLOSE_MODAL,                      {}),
        setHistoryPathname:         makeActionCreator(Types.SET_HISTORY_PATHNAME,             { pathname: T.string }),
        setHistoryPreviousPathname: makeActionCreator(Types.SET_HISTORY_PREVIOUS_PATHNAME,    { pathname: T.string }),
        rememberScroll:             makeActionCreator(Types.REMEMBER_SCROLL,                  { type: T.oneOf(['discover', 'group']) }, {
            propTransform: ({ type }) => {

                return { type: { [type]: internals.getScrollContainer()?.scrollTop || 0 } };
            }
        }),
        restoreScroll: makeActionCreator(Types.RESTORE_SCROLL, { type: T.oneOf(['discover', 'group']) }, {
            propTransform: ({ type }, { state }) => {

                if (state.app.rememberedScroll !== null && internals.getScrollContainer()) {
                    internals.getScrollContainer().scrollTop = state.app.rememberedScroll?.[type] || 0;
                }

                return { type };
            }
        }),
        clearValuesForSchoolSwitch: makeActionCreator(Types.CLEAR_VALUES_FOR_SCHOOL_SWITCH, {}),
        setShouldRefreshSearch: makeActionCreator(Types.SHOULD_REFRESH_SEARCH, { discover: T.bool, group: T.bool }),
        setIsDowntimeMode: makeActionCreator(Types.IS_DOWNTIME_MODE, {
            value: T.bool,
            message: T.string,
            type: T.oneOf(['maintenance', 'service-unavailable'])
        }),
        setIsForceAppUpgradeMode: makeActionCreator(Types.IS_FORCE_APP_UPGRADE_MODE, { value: T.bool, apiAppVersion: T.string, frontendAppVersion: T.string }),
        setDiscoverNavigation: makeActionCreator(Types.SET_DISCOVER_NAVIGATION, { currentResultIndex: T.number, fromDiscover: T.bool }),
        clearDiscoverNavigation: makeActionCreator(Types.CLEAR_DISCOVER_NAVIGATION, {}),
        setGroupNavigation: makeActionCreator(Types.SET_GROUP_NAVIGATION, { currentResultIndex: T.number, fromGroup: T.bool, groupId: T.number }),
        clearGroupNavigation: makeActionCreator(Types.CLEAR_GROUP_NAVIGATION, {}),
        setDebug: makeActionCreator(Types.SET_DEBUG, { debug: T.object }, {
            after: ({ payload: { debug: { discoverMatching } } }) => {

                // Clear and reset Discover search if previous search did not have debug matching flag set.

                const state = redux.getState();

                const lastUserSearch = selectors.getLastUserSearch(state);

                if (discoverMatching && lastUserSearch.criteria && !lastUserSearch.criteria.debugMatching) {
                    const discoverSortType = selectors.getDiscoverSortType(state);

                    if (discoverSortType !== USERS_SORT_TYPE.BEST_MATCH) {
                        redux.dispatch(actions.app.setDiscoverSortType({
                            type: USERS_SORT_TYPE.BEST_MATCH
                        }));
                    }

                    const discoverRoleGroupFilter = selectors.getRoleGroupFilter(state, 'discover');

                    if (discoverRoleGroupFilter !== 'all') {
                        redux.dispatch(actions.app.setRoleGroupFilter({
                            discover: 'all'
                        }));
                    }

                    redux.dispatch(actions.app.setDiscoverSearchFilter({ filter: {} }));

                    redux.dispatch(actions.dataFetching.fetchDiscoverSearchResults.firstPage({
                        allByMatches: true,
                        sortType: USERS_SORT_TYPE.BEST_MATCH,
                        debugMatching: true
                    }));
                }
            }
        })
    };
};

// Lazy require to avoid circular dep
internals.getScrollContainer = () => document.getElementById(ELEMENT_IDS.scrollContainer);
